<button
  class="h-12 w-12 flex-shrink-0 rounded-full transition-all [&.open]:bg-white [&.open]:shadow-lg dark:[&.open]:text-[#1E1E1E]"
  type="button"
  [attr.aria-expanded]="isOpen() ? 'true' : 'false'"
  [attr.aria-controls]="isOpen() ? 'search-panel' : null"
  [ngClass]="[isOpen() ? 'open' : '']"
  (click)="isOpen.set(!isOpen())"
  matRipple
>
  <sheba-search-icon />
  <span class="sr-only">{{ 'SHARED.ACCESSIBILITY.SEARCH_ICON' | translate }}</span>
</button>

<ng-template
  #overlay="cdkConnectedOverlay"
  [cdkConnectedOverlayOrigin]="overlayOrigin()"
  [cdkConnectedOverlayPositions]="[{ originX: 'center', originY: 'bottom', overlayX: 'center', overlayY: 'top' }]"
  [cdkConnectedOverlayScrollStrategy]="blockScrollStrategy"
  [cdkConnectedOverlayOpen]="isOpen()"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayBackdropClass]="['opacity-1']"
  [cdkConnectedOverlayDisableClose]="false"
  (detach)="isOpen.set(false)"
  (backdropClick)="isOpen.set(false)"
  cdkConnectedOverlay
>
  <div
    class="m-4 flex w-[1024px] flex-col place-content-center place-items-center gap-6 overflow-hidden rounded-3xl bg-white px-6 pb-10 pt-6 shadow-xl md:px-14 md:py-10"
    id="search-panel"
    @openClose
    [cdkTrapFocusAutoCapture]="true"
    (backdropClick)="isOpen.set(false)"
    cdkTrapFocus
  >
    <div class="flex w-full flex-col place-content-between md:flex-row">
      <span class="flex flex-col place-items-center gap-2 text-2xl text-[#1E1E1E] font-bold md:text-lg md:flex-row">
        <div class="block h-12 w-12 p-1">
          <sheba-category-illustrations-icon />
        </div>
        {{ 'HEADER.SEARCH_AREA.SEARCH_THE_SHEBA_SITE' | translate }}
      </span>

      <button
        class="-order-1 h-12 w-12 place-self-end rounded-full p-4 md:order-1"
        type="button"
        (click)="isOpen.set(false)"
        matRipple
      >
        <sheba-close-icon />
        <span class="sr-only">{{ 'HEADER.SEARCH_AREA.CLOSE' | translate }}</span>
      </button>
    </div>

    <!-- TODO: fix search buttons different height -->
    <form
      class="relative flex w-full flex-col items-baseline gap-6 md:flex-row"
      [shebaGtmEvent]="{ event: 'internal_search' }"
      (ngSubmit)="submit()"
    >
      <sheba-search-area
        class="h-[64px] w-full md:h-16 md:w-[70%]"
        [indexName]="indexName"
        [emitOnTextChange]="true"
        (onSearchTextChanged)="model.search = $event"
        (onSearch)="model.search = $event; submit()"
        [navigateOnSelect]="true"
        [fields]="mutableSearchFields"
      />
      <sheba-multi-select
        class="!w-full md:!w-auto"
        [displayFilterByTitle]="false"
        [options]="pageTypes()"
        [filterTitle]="'HEADER.SEARCH_AREA.FILTER_BY' | translate"
        (selectedChange)="model.category = $event"
        [matchButtonWidth]="true"
        buttonCustomClass="!w-full md:!w-[15rem] !h-[64px] md:!h-[3.5rem]"
      />
      <button
        class="h-[64px] w-full w-[18.25rem] md:h-16 md:w-[20%]"
        type="submit"
        [disabled]="!model.search"
        shButton
        color="blue"
        medium
        full
      >
        {{ 'HEADER.SEARCH_AREA.SEARCH' | translate }}
      </button>
    </form>
  </div>
</ng-template>
